module.exports = __webpack_public_path__ + "2350bd9ca63d86e44459f4acfee17197.png";